module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<label class="btn btn-primary btn-block ';
 if (active) {
__p+='active';
}
__p+='">\n	<input type="radio" name="options" id="'+
((__t=(value))==null?'':__t)+
'" checked hidden> '+
((__t=(label))==null?'':__t)+
'\n</label>';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/cart/cart-delivery-address/cart-delivery-tip/cart-delivery-tip-button.html
 ** module id = 441
 ** module chunks = 1 9 15 101 155
 **/